angular.module('bfControllers.standings', []).controller('StandingsController', [
    '$scope', '$rootScope', '$resource', '$cookies', 'helpers',
    function ($scope, $rootScope, $resource, $cookies, helpers) {
        this.standingsList = {};
        this.standingsDealsList = {};
        this.per_page = 10;
        $scope.pagination = new helpers.pagination(this.per_page, 30);
        $scope.composition = {};
        $scope.composition_total = {};

        $rootScope.sort = 'id';
        $rootScope.direct = 'desc';

        var self = this;

        this.getStandings = function () {
            $rootScope.querySent = true;
            // http://ec.term.biflorica:8080/api/standings
            $resource(API_LINK + '/standings/:action',
                {
                    action: 'index',
                    page: $scope.pagination.currPage,
                    sort: $rootScope.sort,
                    direct: $rootScope.direct
                },
                {get: {method: 'GET'}}
            ).get(function (result) {
                self.standingsList = result.data.list;
                $scope.standings = result.data.list;
                var count = parseInt(result.data.count_items);
                var total = parseInt(result.data.total_items);
                $scope.pagination.recountPages(count, total);
                $rootScope.querySent = false;
            });
        };

        $rootScope.renewStandings = $scope.pagination.renewPage = this.getStandings;

        // Действия, которые необходимо выполнить после восстановления соединения с сервером ноды
        $rootScope.$on('afterReconnect', function (event, data) {
            $rootScope.renewStandings();
        });

        $scope.loadStandingDeals = function (standing_id, table_selector, preloader_selector) {
            let is_open = parseInt($(table_selector).attr('is-open'));
            if (is_open) {
                $(table_selector).attr('is-open', 0).slideUp(1000);
            }

            if (typeof (self.standingsDealsList[standing_id]) !== "undefined") {
                if (!is_open)
                    $(table_selector).attr('is-open', 1).slideDown(1000);
                return;
            }
            $(preloader_selector).slideDown(300);
            // http://ec.term.biflorica:8080/api/standings/deals
            $resource(
                API_LINK + '/standings/:action',
                {action: 'deals', 'standing_id': standing_id},
                {get: {method: 'GET'}}
            ).get(function (result) {
                self.standingsDealsList[standing_id] = result.data.list;
                $scope.columnSort = {sortColumn: 'id', reverse: true};
                setTimeout(function(){
                    $(preloader_selector).slideUp(300);
                    $(table_selector).attr('is-open', 1).slideDown(1000);
                }, 500);
            });
        };

        // Выбранные значения сортировки
        var sortValueFromCookies = $cookies.get('sort');
        if (typeof sortValueFromCookies != 'undefined') {
            $rootScope.sort = sortValueFromCookies;
        } else {
            $rootScope.sort = 'id';
            $cookies.put('sort', 'id');
        }
        var directValueFromCookies = $cookies.get('direct');
        if (typeof directValueFromCookies != 'undefined') {
            $rootScope.direct = directValueFromCookies;
        } else {
            $rootScope.direct = 'desc';
            $cookies.put('direct', 'desc');
        }
        this.setSort = function (sort_column) {
            if ($rootScope.sort == sort_column) {
                // Изменяем направление сортировки
                if ($rootScope.direct == 'asc') {
                    $rootScope.direct = 'desc';
                    $cookies.put('direct', 'desc');
                } else {
                    $rootScope.direct = 'asc';
                    $cookies.put('direct', 'asc');
                }
            } else {
                // Изменяем сортировку
                $cookies.put('sort', sort_column);
                $rootScope.sort = sort_column;
            }
            $rootScope.renewStandings();
        };
        $rootScope.setSort = this.setSort;

        $scope.classSort = function (sort_column) {
            if ($rootScope.sort == sort_column) {
                // Изменяем направление сортировки
                if ($rootScope.direct == 'asc') {
                    return 'sorted sorted-up';
                } else {
                    return 'sorted sorted-down';
                }
            }
        };

        $scope.showCompositeInfo = function(request_guid) {
            $resource(API_LINK + '/standings/itemsComposition/id/' + request_guid).get(function (result) {
                $scope.composition = result.data.data.composition
                $scope.composition_total = result.data.data.total
                $('.bf-сomposite-dialog').modal('show');
            });
        };

        // Запуск действий при загрузке страницы
        this.getStandings();

        $scope.showOrder = function (url) {
            window.location.replace(url);
        };
    }
]);
